"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  converterFromSpec: true
};
exports.converterFromSpec = converterFromSpec;
var _ValueConverter = require("./ValueConverter");
var _ConvertType = require("./ConvertType");
Object.keys(_ConvertType).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _ConvertType[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ConvertType[key];
    }
  });
});
var _ConvertTypeRegistry = require("./ConvertTypeRegistry");
Object.keys(_ConvertTypeRegistry).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _ConvertTypeRegistry[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ConvertTypeRegistry[key];
    }
  });
});
var _types = require("./types");
Object.keys(_types).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _types[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _types[key];
    }
  });
});
function converterFromSpec(resolver, context, convert) {
  if (!convert) {
    return null;
  }
  if (Array.isArray(convert)) {
    if (convert.length === 0) {
      return null;
    }
    return new _ValueConverter.SingleValueConverter(convert.map(it => {
      let type = resolver.convertTypeRegistry().get(it.type);
      return {
        type,
        deps: type === null || type === void 0 ? void 0 : type.dependencies(context, it.param, resolver)
      };
    }));
  } else {
    return new _ValueConverter.KeyValueConverter(Object.fromEntries(Object.entries(convert).map(([key, val]) => {
      return [key, new _ValueConverter.SingleValueConverter(val.map(it => {
        let type = resolver.convertTypeRegistry().get(it.type);
        return {
          type,
          deps: type === null || type === void 0 ? void 0 : type.dependencies(context, it.param, resolver)
        };
      }))];
    })));
  }
}
//# sourceMappingURL=index.js.map